import type { MonetaryAmountDto } from "./MonetaryAmountDto";

export enum TenderPublicListingInfoStatus {
    "DRAFT" = "DRAFT",
    "ACCEPTANCE_PROPOSALS" = "ACCEPTANCE_PROPOSALS",
    "DOCUMENTS_ACCEPTANCE" = "DOCUMENTS_ACCEPTANCE",
    "REVIEW_PROPOSALS" = "REVIEW_PROPOSALS",
    "REBIDDING" = "REBIDDING",
    "COMPLETED" = "COMPLETED"
}
export type TenderPublicListingInfo = {
    /**
     * @type integer int64
    */
    id: number;
    /**
     * @type string uuid
    */
    uid: string;
    /**
     * @type string | undefined
    */
    name?: string;
    /**
     * @type string
    */
    categoryName: string;
    /**
     * @type string | undefined date-time
    */
    startDateProposals?: string;
    /**
     * @type string | undefined date-time
    */
    endDateProposals?: string;
    /**
     * @type string
    */
    status: TenderPublicListingInfoStatus;
    /**
     * @type string
    */
    ownerOrganization: string;
    /**
     * @type string
    */
    regionName: string;
    cost?: MonetaryAmountDto;
    /**
     * @type integer int64
    */
    itemsQuantity: number;
    /**
     * @type boolean
    */
    isMyTender: boolean;
};
